type LogLevel = 'debug' | 'info' | 'log' | 'warn' | 'error'

export interface Logger {
  debug: (message: unknown, ...args: unknown[]) => void
  info: (message: unknown, ...args: unknown[]) => void
  log: (message: unknown, ...args: unknown[]) => void
  warn: (message: unknown, ...args: unknown[]) => void
  error: (message: unknown, ...args: unknown[]) => void
}

const createLogger = (namespace?: string): Logger => {
  const isProd = import.meta.env.MODE === 'production'

  const formatMessage = (level: LogLevel): string => {
    const timestamp = new Date().toISOString().slice(11, 23)
    const prefix = namespace ? `[${namespace}]` : ''
    const levelPrefix = `[${level.toUpperCase()}]`
    return `${timestamp} ${levelPrefix} ${prefix}`.trim()
  }

  const createLogFunction = (level: LogLevel) => {
    return (message: unknown, ...args: unknown[]) => {
      // Production: ONLY warn and error
      if (isProd && level !== 'warn' && level !== 'error') {
        return
      }

      // Development & Staging: ALL logs
      const formattedPrefix = formatMessage(level)
      console[level](formattedPrefix, message, ...args)
    }
  }

  return {
    debug: createLogFunction('debug'),
    info: createLogFunction('info'),
    log: createLogFunction('log'),
    warn: createLogFunction('warn'),
    error: createLogFunction('error'),
  }
}

export { createLogger }
